export default __webpack_public_path__ + "static/media/loginSvgAcium.52671b0b.svg";